export const PHONE_CHANNEL = 'jarvis-llmbot-next-phone/v1'
const STATES = new Set(['awaiting-connect', 'connecting', 'connected', 'disconnected', 'error'])
const PHONE_MODES = new Set(['auto', 'collaboration'])
export const phoneFrameUrl = mode => {
  if (!PHONE_MODES.has(mode)) throw new Error('Unsupported phone mode')
  return `/phone-next/login?mode=llmbot&phoneMode=${encodeURIComponent(mode)}&lang=en-US`
}
export function phoneStatusLabel(state, activeCall) {
  if (activeCall) return 'Incoming or active call'
  return ({ loading: 'Loading phone', 'awaiting-connect': 'Waiting to connect', connecting: 'Connecting phone', connected: 'Phone connected', disconnected: 'Phone disconnected', error: 'Phone connection error' })[state] || 'Phone not open'
}
export function createPhoneBridge({ origin, getFrame, getToken, getMode, onStatus, onClear }) {
  let destroyed = false
  return {
    receive(event) {
      const frame = getFrame()
      if (destroyed || !frame || event.source !== frame || event.origin !== origin || event.data?.channel !== PHONE_CHANNEL) return
      const data = event.data
      if (data.type === 'ready') {
        const token = getToken()
        const phoneMode = getMode()
        if (typeof token !== 'string' || !token || !PHONE_MODES.has(phoneMode)) { onClear(); return }
        frame.postMessage({ channel: PHONE_CHANNEL, type: 'session', token, phoneMode }, origin)
      } else if (data.type === 'status' && STATES.has(data.state) && typeof data.activeCall === 'boolean') {
        onStatus({
          state: data.state,
          activeCall: data.activeCall,
          agentState: typeof data.agentState === 'string' ? data.agentState : '',
        })
      } else if (data.type === 'session-clear') onClear()
    },
    destroy() {
      if (destroyed) return
      destroyed = true
      getFrame()?.postMessage({ channel: PHONE_CHANNEL, type: 'session-clear' }, origin)
    },
  }
}
